import { render, staticRenderFns } from "./SalaryTaxSlab.vue?vue&type=template&id=250850e8&scoped=true&"
import script from "./SalaryTaxSlab.vue?vue&type=script&lang=js&"
export * from "./SalaryTaxSlab.vue?vue&type=script&lang=js&"
import style0 from "./SalaryTaxSlab.vue?vue&type=style&index=0&id=250850e8&lang=scss&scoped=true&"
import style1 from "./SalaryTaxSlab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250850e8",
  null
  
)

export default component.exports